import { render, staticRenderFns } from "./worldcup.vue?vue&type=template&id=f20769b4&"
import script from "./worldcup.vue?vue&type=script&lang=js&"
export * from "./worldcup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports